import React, { forwardRef } from 'react';
import { Link } from 'gatsby';

const DefaultButton = forwardRef((props, ref) => {
	const {
		as = 'link',
		to,
		type,
		size,
		variant,
		children,
		className,
		...rest
	} = props;

	const Defaults = {
		size: 'py-2 px-6',
		variant: 'inline-block font-semibold transition-colors',
		type: 'button'
	};

	const ButtonVariant = {
		primary:
			'bg-button-primary-background-default text-button-primary-color hover:bg-button-primary-background-hover focus:bg-button-primary-background-hover',
		secondary:
			'bg-button-secondary-background-default text-button-secondary-color hover:bg-button-secondary-background-hover focus:bg-button-secondary-background-hover',
		tertiary: 'bg-gray-500 text-white hover:bg-gray-600 focus:bg-gray-500',
		link: 'underline !font-normal !p-0 text-button-link-color-default  hover:text-button-link-color-hover hover:no-underline focus:text-button-link-color-hover focus:no-underline',
		transparent:
			'text-button-transparent-color-default hover:text-button-transparent-color-hover focus:text-button-transparent-color-hover',
		outline:
			'group text-button-outline-color-default hover:bg-button-outline-background-hover hover:text-button-outline-color-hover focus:bg-button-outline-background-hover focus:text-button-outline-color-hover',
		white:
			'bg-button-white-background-default text-button-white-color-default hover:bg-button-white-background-hover hover:text-button-white-color-hover focus:bg-button-white-background-hover focus:text-button-white-color-hover'
	};

	const ButtonSize = {
		sq: 'p-2 text-sm',
		xs: 'py-2 px-3 text-xs',
		sm: 'py-1 px-3 text-sm',
		lg: 'py-4 px-10 text-lg'
	};

	switch (as.toLowerCase()) {
		case 'a':
			return (
				<a
					href={to}
					target={to && to.indexOf('/cart') >= 0 ? '_top' : '_blank'}
					rel="nofollow noreferrer"
					className={`!no-underline
					${size ? ButtonSize[size] : Defaults.size}
					${Defaults.variant}
					${variant ? ButtonVariant[variant] : ''}
					${className ?? ''}
				`}
					{...rest}
				>
					{children}
				</a>
			);
		case 'button':
			return (
				<button
					ref={ref}
					type={type ? type : Defaults.type}
					className={`
					${size ? ButtonSize[size] : Defaults.size}
					${Defaults.variant}
					${variant ? ButtonVariant[variant] : ''}
					${className ?? ''}
				`}
					{...rest}
				>
					{children}
				</button>
			);
		default:
			return (
				<Link
					to={to}
					className={`
					${size ? ButtonSize[size] : Defaults.size}
					${Defaults.variant}
					${variant ? ButtonVariant[variant] : ''}
					${className ?? ''}
				`}
					{...rest}
				>
					{children}
				</Link>
			);
	}
});

DefaultButton.displayName = 'Button';
export default DefaultButton;
